import React from 'react';
import { Phone, Clock, MapPin, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './OrderPage.css';

const OrderPage = () => {
  const navigate = useNavigate();

  return (
    <div className="order-page">
      <div className="order-container">
        <button onClick={() => navigate('/')} className="back-button">
          <ArrowLeft size={20} />
          Back to Home
        </button>

        <div className="order-content">
          <div className="order-header">
            <h1 className="order-title">Call to Order</h1>
            <p className="order-subtitle">Contact us directly to place your order</p>
          </div>

          <div className="order-card hover-lift">
            <div className="order-icon">
              <Phone size={48} />
            </div>
            <h2 className="order-phone-title">Call Us Now</h2>
            <a href="tel:07402807007" className="order-phone-number">
              07402 807007
            </a>
            <p className="order-description">
              Our team is ready to take your order and answer any questions
            </p>
          </div>

          <div className="order-info-grid">
            <div className="order-info-card hover-lift">
              <div className="info-icon-small">
                <Clock size={24} />
              </div>
              <h3 className="info-card-title">Opening Hours</h3>
              <div className="info-details">
                <p><strong>St George's Rd:</strong></p>
                <p>Mon: Closed</p>
                <p>Tue-Sun: 12:00 PM - 3:00 PM & 6:00 PM - 10:00 PM</p>
                <br />
                <p><strong>Queen Margaret Dr:</strong></p>
                <p>Mon: Closed</p>
                <p>Tue-Sun: 10:00 AM - 10:00 PM</p>
              </div>
            </div>

            <div className="order-info-card hover-lift">
              <div className="info-icon-small">
                <MapPin size={24} />
              </div>
              <h3 className="info-card-title">Locations</h3>
              <div className="info-details">
                <p><strong>St George's Rd</strong></p>
                <p>427 St George's Rd, Glasgow G3 6JX</p>
                <p className="location-type">Take Away Only</p>
                <br />
                <p><strong>Queen Margaret Dr</strong></p>
                <p>106-108 Queen Margaret Dr, Glasgow G20 8N</p>
                <p className="location-type">Take Away & Dine In</p>
              </div>
            </div>
          </div>

          <div className="delivery-info">
            <p className="delivery-text">🚚 Free delivery available up to 2 miles from the location</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderPage;
